/* Total Eyewear — mirror finish live preview (4 Jul 2026).
   Adds a colour swatch + caption next to the wizard's mirror-finish dropdown
   so customers can SEE each finish, not just read a name. CSS-gradient
   approximations of the lab's 2026 range; swap for cropped photos of the
   in-store sample tray when a clean shoot is available (same keys).
   Loads deferred on product pages; exits instantly elsewhere. */
(function () {
  var SWATCHES = {
    'Silver Flash':          ['linear-gradient(135deg,#b9c2cc,#eef3f7 45%,#8fa0b0)', 'Subtle — your tint shows through'],
    'Gold Flash':            ['linear-gradient(135deg,#d8b25e,#f7e9c3 45%,#b58a3a)', 'Subtle — your tint shows through'],
    'Blue Flash':            ['linear-gradient(135deg,#4a7fc1,#bcd8f5 45%,#2c5a9e)', 'Subtle — your tint shows through'],
    'Metallic Silver Solid': ['linear-gradient(135deg,#9aa4ae,#e8edf2 40%,#6e7a86)', 'Full chrome mirror'],
    'Metallic Gold Solid':   ['linear-gradient(135deg,#c9a13b,#f3dfa0 40%,#8f6d1d)', 'Full gold mirror'],
    'Solid Black':           ['linear-gradient(135deg,#20242a,#4a5058 45%,#0d0f13)', 'Dark smoke mirror'],
    'Sapphire Solid':        ['linear-gradient(135deg,#1e3f8f,#5f8fe0 45%,#122a66)', 'Deep blue mirror'],
    'Green Solid':           ['linear-gradient(135deg,#1f6f4a,#63c08f 45%,#124d31)', 'Rich green mirror'],
    'Fire Red Solid':        ['linear-gradient(135deg,#c33a1f,#f2903e 45%,#8f1f12)', 'Red-orange mirror'],
    'Bronze Solid':          ['linear-gradient(135deg,#8a5a2b,#d8a05e 45%,#5f3a18)', 'Warm bronze mirror'],
    'Yellow Solid':          ['linear-gradient(135deg,#d9a91f,#f7dd6e 45%,#a67c10)', 'Bright yellow mirror'],
    'Yellow Silver Solid':   ['linear-gradient(135deg,#cbb85e,#efe9c0 45%,#95864a)', 'Two-tone gold-silver mirror'],
    'Purple Solid':          ['linear-gradient(135deg,#5d2e8c,#a06cd5 45%,#3d1d61)', 'Violet mirror'],
    'Pink Solid':            ['linear-gradient(135deg,#c05a8e,#f0a9cb 45%,#8f3a66)', 'Rose-pink mirror'],
    'Magenta Mirror':        ['linear-gradient(135deg,#8f2d5e,#e06aa4 45%,#5e1c3e)', 'Magenta sheen mirror']
  };

  function boot() {
    var sel = document.querySelector('[data-rxw-mirrorfinish]');
    if (!sel || sel.__rxMirrorPreview) return;
    sel.__rxMirrorPreview = true;

    var wrap = document.createElement('span');
    wrap.style.cssText = 'display:inline-flex;align-items:center;gap:8px;margin-left:4px;';
    var chip = document.createElement('span');
    chip.setAttribute('aria-hidden', 'true');
    chip.style.cssText = 'width:34px;height:34px;border-radius:50%;border:2px solid #e8e4df;flex-shrink:0;box-shadow:inset 0 0 6px rgba(255,255,255,0.35);';
    var cap = document.createElement('span');
    cap.style.cssText = 'font-size:0.72rem;color:#888;font-weight:400;max-width:170px;line-height:1.3;';
    wrap.appendChild(chip); wrap.appendChild(cap);
    sel.parentNode.appendChild(wrap);

    function sync() {
      var s = SWATCHES[sel.value];
      if (s) { chip.style.background = s[0]; cap.textContent = s[1]; }
    }
    sel.addEventListener('change', sync);
    /* the wizard re-syncs the select on render; poll cheaply for value changes it makes programmatically */
    var last = sel.value;
    setInterval(function () { if (sel.value !== last) { last = sel.value; sync(); } }, 400);
    sync();
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
})();
